export default function() {
    const popup = document.querySelector('#popup');
    const modalform = document.querySelector('#modalform');

    document.querySelectorAll('.popup_close').forEach((btn) => {
        btn.addEventListener('click', () => {
            if (popup) popup.style.display = 'none';
        });
    });

    document.addEventListener('click', (event) => {
        if (!event.target.closest('.popup-container')) {
            if (popup) popup.style.display = 'none';
        }
    });

    document.querySelectorAll('.form-file').forEach((el) => el.style.display = 'none');

    document.querySelectorAll('.openform').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const id = btn.getAttribute('data-file');
            if (modalform) modalform.classList.add('show');
            document.querySelectorAll('.form-file').forEach((el) => el.style.display = 'none');
            const target = document.querySelector('.form-' + id);
            if (target) target.style.display = '';
        });
    });

    const close = document.querySelector('.close-form');
    if (close) {
        close.addEventListener('click', function() {
            if (modalform) modalform.classList.remove('show');
            document.querySelectorAll('.form-file').forEach((el) => el.style.display = 'none');
        });
    }
}
